import ScoreA11yWidget from './ScoreA11yWidget';

export default function applyConfig(config) {
  // Add here your project's configuration here by modifying `config` accordingly
  config.settings = {
    ...config.settings,

    appExtras: [
      ...config.settings.appExtras,
      {
        match: '',
        component: ScoreA11yWidget,
      },
    ],
  };

  return config;
}
